import React, { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { viewDoc } from "../../redux/gestorDocumental/actions";
import { useDispatch } from "react-redux";
const LinkDescargaListGD = (props) => {
  //*states
  const [loader, setLoader] = useState(false);
  //*variables
  const dispatch = useDispatch();
  return (
    <Button
      size="sm"
      className="text-secondary rounded"
      variant="link"
      type="button"
      onClick={() =>
        dispatch(viewDoc(props.filters, props.origen, props.cType, setLoader))
      }
    >
      {loader ? <Spinner className="ml-2" animation="border" variant="primary" size="sm" /> : <i className="material-icons">plagiarism</i>}
    </Button>
  );
};

export default LinkDescargaListGD;
